import logo from './images/logo.svg'
import trade from './images/trade.svg'
import learn from './images/learn.svg'
import links from './images/links.svg'
import light from './images/light.svg'
import btn from './images/btn.svg'
import btns from './images/btns.svg'
import booking from './images/booking.svg'
import p1 from './images/p1.svg'
import p2 from './images/p2.svg'
import why from './images/why.svg'
import join from './images/join.svg'
import x from './images/x.svg'
import tg from './images/tg.svg'
import audit from './images/audit.svg'
import arrow from './images/arrow.svg'
import youtube from './images/youtube.svg'
import move from './images/move.gif'
import step from './images/step.gif'
import './index.scss'
import { CaretRightOutlined } from '@ant-design/icons';
import { Collapse, theme } from 'antd';
import { faqlist } from './faq'
export default () => {
    return (
        <div className="content">
            <img src={light} alt="" className='light' />
             {/* header */}
            <div className="header flex flex-center flex-between p-16">
                <img src={logo} alt="" />
                <div className="links flex gap-40">
                     <span className='c230 fz-14 flex flex-center gap-4'>
                        <img src={trade} alt="" />
                        SUDO.Trade
                     </span>
                     <span className='c230 fz-14 flex flex-center gap-4'>
                        <img src={learn} alt="" />
                       Learn
                     </span>
                     <img src={links} alt="" className='pointer' />
                </div>
            </div>
            {/* banner */}
            <div className="flex flex-between flex-center gap-120 p-t-36">
                <div className="flex flex-column c230 flex-start">
                    <div className='fz-60 fwb'>
                    WYSIWYG
                    </div>
                    <div className='fz-36 fwb tl up m-t-10'>
                    Lightning-fast on-chain <br/> transaction experienc
                    </div>
                    <div className='fz-26 tl op-08 m-t-20'>
                    Say goodbye to complicated and tedious Telegram Bot interaction instructions, Sudo.Trade brings you an intuitive and easy-to-use trading experience.
                    </div>
                    <img src={btn} alt="" className='pointer m-t-44' />
                </div>
                <img src={move} alt="" className='move ' />

            </div>
             {/* booking */}

             <div className="booking m-t-65">
                 <img src={booking} alt="" className='bookingbg'/>
                 <div className="book-area flex flex-column flex-center flex-middle gap-30">
                     <div className="fz-36 fwb c230 up ta">
                     Booking Experience
                     </div>
                     <div className="fz-24 c230 ta op-08">
                     Book a Sudo.trade appointment and get early access.
                     </div>
                     <img src={btns} alt="" className='pointer m-t-15' />

                 </div>
                 <img src={step} alt="" className='h-30 step'/>
             </div>

             {/* product */}

             <div className="fz-36 fwb c230 up tl m-t-120">
             Product
             </div>
             <div className="fz-24 c230 op-08 tl m-t-15">
             Book a Sudo.trade appointment and get early access.
             </div>

             <div className="flex flex-start gap-36 p-t-56">
                 <img src={p1} alt="" />
                 <img src={p2} alt="" />
             </div>

             {/* why */}
             <div className="fz-36 fwb c230 up ta m-t-120">
             Why SUDO.Tader is your best <br/>trading partner
             </div>
             <div className="fz-24 c230 op-08 ta m-t-30 desc">
             Experience the superior performance of our advanced technology, ensuring you stay ahead in every transaction. Try our services and feel the difference firsthand.
             </div>
             <img src={why} alt="" className='pointer m-t-40' />
             <img src={join} alt="" className='pointer m-t-40' />

             {/* faq */}
             <div className="flex flex-between p-t-140">
                <div className="fz-36 fwb c230 tl">
                SUDO.Trade Asked & <br/>Questions
                </div>
                <div className="flex flex-column">
                <Collapse
                expandIconPosition="end"
      expandIcon={({ isActive }) => <img src={arrow} style={{color: '#fff', marginTop: '5px', transform: isActive?'rotate(90deg)':'rotate(0deg)'}}  />}
      bordered={false}
      style={{ background: 'transparent', color: '#fff' }}
      items={faqlist}
    />

                </div>

             </div>


             {/* footer */}

             <div className="w100 footer flex flex-center flex-between p-t-68 p-b-68">
                 <div>
                    <div className="flex flex-center gap-10">
                        <a href="/">
                        <img src={x} alt="" />
                        </a>
                        <a href="/">
                        <img src={tg} alt="" />
                        </a>
                        <a href="/">
                        <img src={youtube} alt="" />
                        </a>
                        <a href="/">
                        <img src={audit} alt="" />
                        </a>
                    </div>
                    <div className="tl c230 fz-14 m-t-10">
                    © 2024 SUDO.Trade. All rights reserved.
                    </div>
                 </div>
                 <img src={logo} alt="" className='h-56'/>
             </div>



        </div>
    )
}